import http from '@/support/plugin/axios'

export const 

isValidMobilePhone = ( mobilePhone ) => http.get(`validation/mobile-phone/${mobilePhone}`),

getAccessByEmailOrCpf = ( companyId, telephone, cpf ) => {
  var query

  if(telephone == null) {
    query = '';
  }else {
      query = `?telephone=${telephone}`;
  }

  if(cpf) {
    if(query === '') {
      query = '?'
    } else {
      query+='&'
    }
    query += `cpf=${cpf}`;
  }

  return http.get(`companies/${companyId}/contacts/exists${query}`)
},

getEmailByCompanyIdAndTelephone = ( companyId, telephone ) => http.get(`companies/${companyId}/contacts/email?telephone=${telephone}`)

export function formatTelephoneForUrl( telephone ) {
    if(telephone === '' || telephone === null) {
      return null
    }
    const part0 = telephone.length ? '+55' : ''
    let part1 = telephone.substring(1, 3);
    let part2 = telephone.substring(5, 6);
    let part3 = telephone.substring(7, 11);
    let part4 = telephone.substring(12);

    return `${part0}${part1}${part2}${part3}${part4}`;
}

export function formatCpfForUrl( cpf ) {
  if(cpf === '' || cpf === null) {
    return null
  }
  let part1 = cpf.substring(0, 3);
  let part2 = cpf.substring(4, 7);
  let part3 = cpf.substring(8, 11);
  let part4 = cpf.substring(12);

  return `${part1}${part2}${part3}${part4}`;
}